import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Is this a physical product?',
    answer: "No, it's an instant digital download (PDF). You'll get access immediately after purchase so you can start preparing right away."
  }, {
    question: "What if I'm not closing for a few weeks?",
    answer: "That's perfect. The best time to start is now. The Day-7 checklist is most effective when you review it early, so you're ready when the week arrives."
  }, {
    question: 'Does this replace my real estate agent or lender?',
    answer: 'No. This tool helps you coordinate with them more effectively. It gives you the specific questions to ask at the right times to prevent delays.'
  }, {
    question: 'What if my state has different closing rules?',
    answer: 'The checklist covers universal coordination points like lender fees, title insurance, homeowners insurance, and HOA dues. These core elements apply to almost every US real estate transaction.'
  }, {
    question: 'Is there a refund policy?',
    answer: "Yes. If you don't feel more in control of your closing process, contact us within 30 days for a full refund. No questions asked."
  }, {
    question: 'Why is it so affordable?',
    answer: 'We want every first-time buyer to have access to this protection. The low price removes the barrier — the real value is in preventing a $2,000+ surprise at the closing table.'
  }];
  return <section className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-21">
      <div className="max-w-2xl mx-auto px-6" data-id="element-22">
        <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#1A1A1A] mb-10 lg:mb-14 text-center" data-id="element-23">
          Common Questions
        </h2>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.question} answer={faq.answer} data-id="element-25" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#1B6B3A]/10 last:border-0" data-id="element-26">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-5 flex items-center justify-between text-left group" data-id="element-27">
        <span className="text-lg lg:text-xl font-serif font-medium text-[#1A1A1A] group-hover:text-[#1B6B3A] transition-colors" data-id="element-28">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-[#1B6B3A] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-29" />
      </button>
      <AnimatePresence data-id="element-30">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-31">
            <p className="pb-6 text-base lg:text-lg text-[#3D3D3D] leading-relaxed" data-id="element-32">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}